// NativeModules shim
module.exports={};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/modules/NativeModules/index.js
 ** module id = 521
 ** module chunks = 0
 **/